const ActionDropDown = ({
  showEdit,
  showDelete,
  onClickEdit,
  onClickDelete,
}) => {
  return (
    <div className="d-flex justify-content-end gap-2">
      <div className="dropdown">
        <button
          className="btn btn-sm"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="bi bi-three-dots-vertical"></i>
        </button>
        <ul className="dropdown-menu">
          {showEdit && (
            <li onClick={() => onClickEdit()}>
              <a className="dropdown-item" href="#">
                Edit Budget
              </a>
            </li>
          )}
          {showDelete && (
            <li onClick={() => onClickDelete()}>
              <a className="dropdown-item" href="#">
                Remove Budget
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default ActionDropDown;
